import { AfterContentChecked, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { PlanejamentoOficina } from '../../../core/planejamento-oficina';

@Component({
  selector: 'turma-planejamento-oficina',
  templateUrl: './turma-planejamento-oficina.component.html',
  styleUrls: ['./turma-planejamento-oficina.component.css']
})
export class TurmaPlanejamentoOficinaComponent implements OnInit, AfterContentChecked {

  @Input() planejamentoOficina: PlanejamentoOficina;

  openFormCadastro = false;

  constructor(protected drc: ChangeDetectorRef) {
  }

  ngOnInit() {
  }

  ngAfterContentChecked(): void {
    this.drc.detectChanges();
  }


  onGetAdicionar(evento) {
    this.openFormCadastro = evento;
  }

}
